import { copyLoyaltyInviteLinkEvent, shareLoyaltyLinkThroughWhatsappEvent } from '@/utils/account'
import { capitalize } from '@/utils/general'

export default {
  methods: {
    shareLink ({ medium, link, code, userId = -1 }) {
      switch (medium) {
        // copy
        case 'copy':
          copyLoyaltyInviteLinkEvent({ userId })

          navigator.clipboard.writeText(link).then(() => {
            this.$otoaster.success(this.$t('Loyalty.LinkSharing.CopiedLink'))
          }, () => {
            this.$otoaster.danger(this.$t('Error.general'))
          })
          break

        // whatsapp
        case 'whatsapp':
          shareLoyaltyLinkThroughWhatsappEvent({ userId })

          window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(this.$t('Loyalty.LinkSharing.WhatsAppShareLink', { code, link }))}`, '_blank', 'noopener')
          break

        // mail
        case 'mail':
          window.open(`mailto:?subject=${encodeURIComponent(this.$t('Loyalty.LinkSharing.Email.Subject'))}&body=${encodeURIComponent(this.$t('Loyalty.LinkSharing.Email.Message', { code, link }))}`, '_blank', 'noopener')
          break

        // instagram
        case 'instagram-white':
          window.open('https://instagram.com/_u/onthatass_official/', '_blank', 'noopener')
          break

        // facebook
        case 'facebook-messenger':
          window.open(`https://www.facebook.com/dialog/send?app_id=${process.env.FB_APP_ID}&link=${encodeURIComponent(link)}&redirect_uri=${encodeURIComponent(link)}`, '_blank', 'noopener')
          break

        // twitter
        case 'twitter':
          window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(this.$t('Loyalty.LinkSharing.WhatsAppShareLink', { code, link }))}`, '_blank', 'noopener')
          break
      }
    },
    getReferralLink (referralCode = '', name = '') {
      if (!referralCode) {
        return ''
      }

      const nameParam = name ? `&name=${encodeURIComponent(capitalize(name))}` : ''

      return `${process.env.BASE_URL}/referred-by-friend?ref=${referralCode}${nameParam}`
    }
  }
}
